import { createIcon } from '@chakra-ui/react/icon'

const ImageIcon = createIcon({
  displayName: 'ImageIcon',
  viewBox: '0 0 37 35',
  path: [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.95 5.335c-.932 0-1.827.366-2.486 1.018a3.459 3.459 0 0 0-1.03 2.46v17.389c0 .922.37 1.807 1.03 2.46A3.537 3.537 0 0 0 7.95 29.68h21.1c.932 0 1.827-.366 2.486-1.019a3.459 3.459 0 0 0 1.03-2.459V8.812c0-.922-.37-1.806-1.03-2.459a3.536 3.536 0 0 0-2.486-1.018H7.95Zm21.1 20.867H7.95l7.033-13.912 5.275 10.434 3.517-6.956 5.275 10.434Z"
      clipRule="evenodd"
    />,
  ],
})

export default ImageIcon
